/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  pin(conversationID) {
    return axios.post(`${this.url}/${conversationID}/pinned`);
  }

  unpin(conversationID) {
    return axios.delete(`${this.url}/${conversationID}/pinned`);
  }

  fetchGroupParticipants(conversationID) {
    return axios.get(`${this.url}/${conversationID}/group_participants`);
  }
}

export default new ConversationApi();
